import LogoMain from '@/assets/svg/logos/logo-main.svg';
import { theme, Typography } from '@/design-system';

import { Header, Main, NoticeButton, Shell } from '../full-page-notice/styled';

export const MaintenancePage = () => {
  const handleRefresh = () => window.location.reload();

  return (
    <Shell>
      <Header>
        <LogoMain role="img" aria-label="Gamma Prime" />
      </Header>
      <Main>
        <Typography variant="h4" as="h1">
          We’ll be back shortly
        </Typography>
        <Typography variant="body2" color={theme.colors.text.secondary}>
          Gamma Prime is temporarily unavailable while we carry out scheduled maintenance.
        </Typography>
        <NoticeButton type="button" size="lg" onClick={handleRefresh}>
          Refresh page
        </NoticeButton>
      </Main>
    </Shell>
  );
};
